module.exports = __webpack_public_path__ + "static/img/ns_logo.5c6993d8.png";